// External deps
import { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Accordion } from 'ypf-pas-general-ui-components';
import { useFormikContext } from 'formik';

// Internal deps
import { stepEnumOfAccordion } from '../../Constants';

import LeftContentServiceAccordion from './LeftContentServiceAccordion';
import RightContentServiceAccordion from './RightContentServiceAccordion';
import BodyAccordion from './BodyAccordion';
import './ServiceAccordion.scss';

const ServiceAccordion = ({
  disabledAllFields,
  isAutocomplete,
  isApplyTemplateRequest,
  accordionIndex,
  showContentAccordion,
  insertAccordion,
  notificationOptions,
  removeAccordion,
  handleModalState,
  setAccordionOpen,
  backToUbicationForm
}) => {
  const [accordionHasErrors, setAccordionHasErrors] = useState(false);

  const { values, errors, setFieldValue } = useFormikContext();

  const setStep = (step) => setFieldValue(`accordions[${accordionIndex}].accordionStep`, step);

  const handleServiceCompleted = (hasErrors) => {
    setAccordionHasErrors(hasErrors);
  };

  const isServiceCompleted =
    values?.accordions[accordionIndex]?.accordionStep >= stepEnumOfAccordion.associatedUsers;

  const toggleThisAccordion = (newOpenState) => {
    if (newOpenState && !isApplyTemplateRequest) setStep(stepEnumOfAccordion.service);
    setAccordionOpen(newOpenState ? accordionIndex : null);
  };

  const probDate = values?.accordions[accordionIndex].service?.probDate;
  const needDate = values?.accordions[accordionIndex].service?.needDate;
  const serviceName = values?.accordions[accordionIndex].service?.service?.nombre;

  const getAccordionTitle = () => {
    if (probDate && serviceName) {
      return `${dayjs(probDate).format('DD/MM/YYYY')} - ${serviceName}`;
    }
    if (serviceName) {
      return serviceName;
    }

    return undefined;
  };

  const serviceFormIncomplete = errors?.accordions && !!errors?.accordions[accordionIndex]?.service;

  return (
    <div className="container-service-accordion">
      <Accordion
        availableManualOpening
        className="service-accordion"
        leftContent={
          <LeftContentServiceAccordion
            state={
              !accordionHasErrors && isServiceCompleted && probDate && needDate
                ? 'complete'
                : 'incomplete'
            }
            title={getAccordionTitle()}
          />
        }
        restrictedOpening
        rightContent={
          <RightContentServiceAccordion
            dataService={{
              fecha: probDate,
              nombre: serviceName
            }}
            disabledAllFields={disabledAllFields}
            handleAddService={(index, needDateToAdd, probDateToAdd) => {
              if (disabledAllFields) return;
              insertAccordion(index, needDateToAdd, probDateToAdd);
              setAccordionOpen(null);
            }}
            handleModalState={handleModalState}
            hasOneAccordion={values?.accordions.length === 1}
            index={accordionIndex}
            needDate={needDate}
            probDate={probDate}
            removeAccordion={() => {
              if (disabledAllFields) return;
              removeAccordion();
            }}
            serviceFormIncomplete={serviceFormIncomplete}
          />
        }
        setShowManualContent={toggleThisAccordion}
        showManualContent={showContentAccordion}
        width="100%"
      >
        <BodyAccordion
          accordionIndex={accordionIndex}
          accordionOpen={showContentAccordion}
          backToUbicationForm={backToUbicationForm}
          disabledAllFields={disabledAllFields}
          handleServiceCompleted={handleServiceCompleted}
          isApplyTemplateRequest={isApplyTemplateRequest}
          isAutocomplete={isAutocomplete}
          notificationOptions={notificationOptions}
        />
      </Accordion>
    </div>
  );
};

ServiceAccordion.propTypes = {
  isAutocomplete: PropTypes.bool,
  isApplyTemplateRequest: PropTypes.bool,
  disabledAllFields: PropTypes.bool,
  showContentAccordion: PropTypes.bool.isRequired,
  accordionIndex: PropTypes.number.isRequired,
  handleModalState: PropTypes.func.isRequired,
  insertAccordion: PropTypes.func.isRequired,
  notificationOptions: PropTypes.arrayOf(PropTypes.shape({})),
  removeAccordion: PropTypes.func.isRequired,
  setAccordionOpen: PropTypes.func,
  backToUbicationForm: PropTypes.func.isRequired
};
ServiceAccordion.defaultProps = {
  disabledAllFields: false,
  isAutocomplete: false,
  isApplyTemplateRequest: false,
  notificationOptions: [],
  setAccordionOpen: () => {
    /* Empty */
  }
};
export default ServiceAccordion;
